var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.pageTitle)?_c('h1',{staticClass:"d-flex justify-center"},[_vm._v(_vm._s(_vm.pageTitle))]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }